import { Component, Input, OnInit } from '@angular/core';
import IBulkOperationStatistic = ZoningAPI.IBulkOperationStatistic;
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-bulk-operation-statistic',
    templateUrl: './bulk-operation-statistic.component.html',
    styleUrls: ['./bulk-operation-statistic.component.scss']
})
export class BulkOperationStatisticComponent implements OnInit {
    _data: IBulkOperationStatistic;

    get data(): IBulkOperationStatistic {
        return this._data;
    }

    @Input()
    set data(value: IBulkOperationStatistic) {
        this._data = value;
        this.initValues();
    }
    failedRecordsIdsStr: string;

    constructor() {}

    ngOnInit(): void {}

    initValues() {
        this.failedRecordsIdsStr = _.get(this, 'data.failedRecordsIds', []).join(', ');
    }
}
